import { config, XSSPlugin } from 'md-editor-rt';
import markdownit from 'markdown-it';

config({
  // markdownItConfig(md) {
  //   MarkdownService.configureMarkdownIt(md);
  // },
  markdownItPlugins(plugins) {
    return [
      ...plugins,
      {
        type: 'xss',
        plugin: XSSPlugin,
        options: {},
      },
    ];
  }
})

export class MarkdownService {

  public static configureMarkdownIt(md: markdownit) {

    md.options.html = true;
    md.options.linkify = true;
    md.options.breaks = false;

    // Remember the old renderer if overridden, or proxy to the default renderer.
    var defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, _env, self) {
      return self.renderToken(tokens, idx, options);
    };

    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      // Add a new `target` attribute, or replace the value of the existing one.
      tokens[idx].attrSet('target', '_blank');

      // Pass the token to the default renderer.
      return defaultRender(tokens, idx, options, env, self);
    };
  }

  private static createMarkdownIt() {
    const md = markdownit();
    MarkdownService.configureMarkdownIt(md);
    return md;
  }

  private static markdown = MarkdownService.createMarkdownIt();

  public static render(md: string) {

    // replaced with [summaryLabel] attribute
    // const match = md.match(/(\[.*?\])$/);
    // if (match) {
    //   md = md.substring(0, md.length - match[1].length);
    // }

    let str = MarkdownService.markdown.render(md);

    str = str.trim();

    if (str.startsWith('<p>')) {
      str = str.substring(3);
    }
    if (str.endsWith('</p>')) {
      str = str.substring(0, str.length - 4);
    }

    return str;
  }

}